// 公共组件 使用场景
export default {
    'useSence.tips1': 'Please select the usage scenario',
    'useSence.tips2': 'Please select the usage scenario (required)' ,
}
 